module.exports = __webpack_public_path__ + "static/rinfoltitura-915e273dde63456768a671cf7fcd0434.jpg";